module.exports = __webpack_public_path__ + "img/bj-check.23816b9e.jpg";